/*
 * Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Component } from '@angular/core';
import {PendingComponent} from "@ng-falcon/pending/pending.component";

@Component({
    selector: 'ngf-entire-window-pending',
    templateUrl: './entire-window-pending.component.html',
    styleUrls: ['./entire-window-pending.component.scss'],
    imports: [
        PendingComponent
    ]
})
export class EntireWindowPendingComponent {
}
